<template>
	<span class="svg-icon" v-html="require(`!!html-loader!./../assets/icon/${icon}.svg`)"></span>
</template>

<script>
export default {
	props: ['icon']
}
</script>